// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"a3c7d1dcb331394545d0","655":"06ea3db3ebccdc821e82"}[chunkId] + ".js";
};